import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { EnvService } from './env.service';

export const EnvServiceFactory = (platformId: Object) => {
    const env = new EnvService();
    if (isPlatformBrowser(platformId)) {
        const browserWindow = window || {};
        const browserWindowEnv = browserWindow['__env'] || {};

        for (const key in browserWindowEnv) {
            if (Object.prototype.hasOwnProperty.call(browserWindowEnv, key)) {
                env[key] = browserWindowEnv[key];
            }
        }
        // console.log(browserWindowEnv);

    } else {
        // Here you can provide some default values for server side rendering if needed
        // Mirrors the derived values set in src/env.js for the browser, so SSR-rendered
        // meta tags (citation_pdf_url, og:image, etc.) resolve to real absolute URLs
        // instead of being left blank for crawlers that don't execute JS.

        const siteUrl = 'https://journal.thebritishacademy.ac.uk/';
        const apiUrl = 'https://journal.thebritishacademy.ac.uk/admin/backend/';

        // const siteUrl = 'https://staging-jba-rvhost.rivervalleytechnologies.in/';
        // const apiUrl = 'https://staging-jba-rvhost.rivervalleytechnologies.in/';

        // const siteUrl = 'http://localhost/';
        // const apiUrl = 'http://localhost/rvhost_jba/backend/';

        env['siteUrl'] = siteUrl;
        env['apiUrl'] = apiUrl;
        env['siteApiUrl'] = apiUrl + 'public/api/';
        env['publicUrl'] = apiUrl + 'public/';
        env['imageUrl'] = apiUrl + 'storage/app/public/uploads/';
        env['articleUrl'] = apiUrl + 'storage/app/articles/';
        env['chapterXmlUrl'] = apiUrl + 'storage/app/book/';
        env['bookXmlImageUrl'] = apiUrl + 'storage/app/public/assets/book/';
        env['coverImageUrl'] = apiUrl + 'storage/app/public/cover_images/book/';
        env['articleCoverImage'] = apiUrl + 'storage/app/public/cover_images/journals/';
        env['defaultImagePath'] = apiUrl + 'storage/app/public/assets/';
        env['articleImage'] = apiUrl + 'storage/';
        env['downloadFilePath'] = apiUrl + 'public/api/web/article-download-count';
        env['userProfile'] = apiUrl + 'storage/app/public/images/web_user/';
        env['editorialImage'] = apiUrl + 'storage/app/public/uploads/editorials/';
        env['rssFeed'] = apiUrl + 'storage/app/public/feed/rss_feed.xml';
        env['bannerImage'] = apiUrl + 'storage/app/public/banner_images';
        env['default_article_cover_image_upto_11'] = apiUrl + 'storage/app/public/assets/default_article_cover_image_upto_11.webp';
        env['default_article_cover_image_above_11'] = apiUrl + 'storage/app/public/assets/default_article_cover_image_above_11.webp';
    }
    return env;
};

export const EnvServiceProvider = {
    provide: EnvService,
    useFactory: EnvServiceFactory,
    deps: [PLATFORM_ID],
};
